var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDurationBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167969,
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_7878_166723)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3047 7.66663H11.0338C10.6484 7.66663 10.3359 7.97907 10.3359 8.36449C10.3359 10.5855 11.2182 12.7156 12.7887 14.2861L13.8047 15.3021C13.9056 15.403 13.9561 15.4534 13.9922 15.5019C14.2125 15.7974 14.2125 16.2025 13.9922 16.498C13.9561 16.5465 13.9056 16.5969 13.8047 16.6978L12.7887 17.7138C11.2182 19.2843 10.3359 21.4144 10.3359 23.6354C10.3359 24.0208 10.6484 24.3333 11.0338 24.3333H21.3047C21.6902 24.3333 22.0026 24.0208 22.0026 23.6354C22.0026 21.4144 21.1203 19.2843 19.5498 17.7138L18.5338 16.6978C18.4329 16.5969 18.3825 16.5465 18.3464 16.498C18.126 16.2025 18.126 15.7974 18.3464 15.5019C18.3825 15.4534 18.4329 15.403 18.5338 15.3021L19.5498 14.2861C21.1203 12.7156 22.0026 10.5855 22.0026 8.36449C22.0026 7.97907 21.6902 7.66663 21.3047 7.66663Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7878_166723",
    x1: 29.668,
    y1: 27,
    x2: 3.66797,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationBlue);
export default __webpack_public_path__ + "static/media/duration-blue.aac86d92909692c5a68afe86087c35de.svg";
export { ForwardRef as ReactComponent };